import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './pages/login/login.component';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {MatMenuModule} from '@angular/material/menu';
import { MatSliderModule } from '@angular/material/slider';
import {MatButtonModule} from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import { LeftMenuComponent } from './components/left-menu/left-menu.component';
import {MatListModule} from '@angular/material/list';
import { PreferredPricingComponent } from './pages/preferred-pricing/preferred-pricing.component';
import { AccountComponent } from './pages/account/account.component';
import {MatTabsModule} from '@angular/material/tabs';
import { HeaderComponent } from './components/header/header.component';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {AuthInterceptorService} from "./services/auth-interceptor.service";
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {environment} from "../environments/environment";
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import { GenerateContractDialogComponent } from './components/dialog/generate-contract-dialog/generate-contract-dialog.component';
import {MatDividerModule} from '@angular/material/divider';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatBadgeModule} from '@angular/material/badge';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PriceHistoryComponent } from './components/price-history/price-history.component';
import { PriceHistoryDetailDialogComponent } from './components/dialog/price-history-detail-dialog/price-history-detail-dialog.component';
import { ActiveQuoteComponent } from './pages/active-quote/active-quote.component';
import { ActiveQuoteDialogComponent } from './components/dialog/active-quote-dialog/active-quote-dialog.component';
import { ActiveTermsDialogComponent } from './components/dialog/active-terms-dialog/active-terms-dialog.component';
import {MatNativeDateModule} from "@angular/material/core";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";
import {MatPaginatorModule} from "@angular/material/paginator";
import { CdkColumnDef } from '@angular/cdk/table'
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { MenuItemComponent } from './components/header/menu-item/menu-item.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { FavoriteIconComponent } from './pages/active-quote/favorite-icon/favorite-icon.component';
import { NewQuoteRequestComponent } from './pages/new-quote-request/new-quote-request.component';
import { RequestHistoryComponent } from './pages/request-history/request-history.component';
import {MatChipsModule} from "@angular/material/chips";
import {MatStepperModule} from "@angular/material/stepper";
import { DragNDropFilesDirective } from './components/file-attachments/drag-n-drop-files.directive';
import { FileAttachmentsComponent } from './components/file-attachments/file-attachments.component';
import { DownloadContractDialogComponent } from './components/dialog/download-contract-dialog/download-contract-dialog.component';
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import { DataTableComponent } from './components/data-table/data-table.component';
import { MarketTableComponent } from './components/market-table/market-table.component';
import { DashbaordFooterComponent } from './components/dashbaord-footer/dashbaord-footer.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import {NgApexchartsModule} from "ng-apexcharts";
import { DashboardContactInfoComponent } from './components/dashboard-contact-info/dashboard-contact-info.component';
import {MatBottomSheetModule} from "@angular/material/bottom-sheet";
import { MatrixRequestHistoryComponent } from './pages/matrix-request-history/matrix-request-history.component';
import { ActiveIconComponent } from './pages/active-quote/active-icon/active-icon.component';
import { AdminComponent } from './pages/admin/admin.component';
import {RouteResolverService} from "./services/route-resolver.service";
import { ContractTemplatesComponent } from './pages/contract-templates/contract-templates.component';
import { AsyncSelectComponent } from './components/async-select/async-select.component';
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import { PaidCommissionsComponent } from './components/dialog/paid-commissions/paid-commissions.component';
import { DisableContractsComponent } from './pages/disable-contracts/disable-contracts.component';



const oktaConfig = {
  redirectUri: environment.redirectUri,
  baseUrl: environment.baseUrl,
  clientId: environment.clientId,
  issuer: environment.issuer,
  pkce: false,
  scopes: ['openid', 'profile'],
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    LeftMenuComponent,
    PreferredPricingComponent,
    AccountComponent,
    HeaderComponent,
    GenerateContractDialogComponent,
    PriceHistoryComponent,
    PriceHistoryDetailDialogComponent,
    ActiveQuoteComponent,
    ActiveQuoteDialogComponent,
    ActiveTermsDialogComponent,
    MenuItemComponent,
    PageNotFoundComponent,
    FavoriteIconComponent,
    NewQuoteRequestComponent,
    RequestHistoryComponent,
    DragNDropFilesDirective,
    FileAttachmentsComponent,
    DownloadContractDialogComponent,
    DataTableComponent,
    MarketTableComponent,
    DashbaordFooterComponent,
    LineChartComponent,
    DashboardContactInfoComponent,
    MatrixRequestHistoryComponent,
    ActiveIconComponent,
    AdminComponent,
    ContractTemplatesComponent,
    AsyncSelectComponent,
    PaidCommissionsComponent,
    DisableContractsComponent

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    OktaAuthModule,
    NgbModule,
    MatMenuModule,
    MatSliderModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatTabsModule,
    MatGridListModule,
    MatInputModule,
    MatRadioModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatCardModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatBadgeModule,
    FlexLayoutModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatStepperModule,
    MatSlideToggleModule,
    NgApexchartsModule,
    MatBottomSheetModule
  ],
  providers: [
    { provide: OKTA_CONFIG, useValue: oktaConfig },{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    CdkColumnDef,
    RouteResolverService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
